import React from 'react';
import { FreeConsultLink } from './FreeConsultLink';
import { ArrowRightIcon } from 'lucide-react';
export const TwoPaths = ({
  openModal
}) => {
  return <section className="mb-10" data-id="element-727">
      <h2 className="text-xl font-bold text-blue-800 mb-6 text-center" data-id="element-728">
        Je hebt twee keuzes
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-729">
        <div className="bg-red-50 p-5 rounded-lg border border-red-200" data-id="element-730">
          <h3 className="font-bold text-lg mb-3 text-red-800" data-id="element-731">
            Keuze 1: Blijf doen wat je altijd deed
          </h3>
          <ul className="list-disc pl-6 space-y-2 text-red-800" data-id="element-732">
            <li data-id="element-733">Maanden meer gefrustreerd oefenen zonder resultaat</li>
            <li data-id="element-734">Je hond blijft lijden onder chronische stress</li>
            <li data-id="element-735">Gemiste kansen stapelen zich op</li>
            <li data-id="element-736">Je vrijheid blijft een droom</li>
          </ul>
        </div>
        <div className="bg-green-50 p-5 rounded-lg border border-green-200" data-id="element-737">
          <h3 className="font-bold text-lg mb-3 text-green-800" data-id="element-738">
            Keuze 2: Pak het probleem bij de wortel aan
          </h3>
          <ul className="list-disc pl-6 space-y-2 text-green-800" data-id="element-739">
            <li data-id="element-740">Ontdek binnen 45 minuten wat er écht speelt</li>
            <li data-id="element-741">Zie snelle, duurzame resultaten</li>
            <li data-id="element-742">Krijg je vrijheid terug in 3 maanden</li>
            <li data-id="element-743">Help je hond eindelijk rustig te worden</li>
          </ul>
        </div>
      </div>
      <div className="bg-blue-50 p-6 rounded-lg mb-8 border border-blue-200" data-id="element-744">
        <p className="italic text-blue-800 text-center" data-id="element-745">
          "Je hond verdient een rustig, gelukkig leven zonder constante angst.
          Jij verdient spontaniteit, vrijheid, en een normaal leven. Het enige
          wat tussen jou en dat doel staat, is de juiste diagnose en aanpak. Die
          krijg je vandaag. Gratis. Zonder verplichtingen."
        </p>
      </div>
      <div className="text-center" data-id="element-746">
        <a href="https://training.stresslessdogs.nl/va-video" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg transition duration-200 inline-flex items-center" data-id="element-747">
          JA, IK WIL MIJN GRATIS INTAKE GESPREK PLANNEN
          <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-748" />
        </a>
        <p className="text-sm text-gray-600 mt-3" data-id="element-749">
          De vraag is niet óf het werkt - onze 100+ succesvolle cliënten
          bewijzen dat het werkt.
          <br data-id="element-750" />
          De vraag is: ben jij klaar om je leven terug te krijgen?
        </p>
      </div>
      <div className="text-center mt-8 text-gray-600 italic" data-id="element-751">
        <p data-id="element-752">
          P.S. Nog steeds aan het twijfelen? Denk aan gisteren toen je weer niet
          weg kon. Denk aan morgen als het weer gebeurt. En overmorgen. Hoeveel
          dagen wil je nog gevangen blijven in je eigen huis?
        </p>
        <p className="mt-2" data-id="element-753">
          Het gesprek is gratis. Je hebt niets te verliezen behalve je
          gevangenschap.
        </p>
      </div>
    </section>;
};